import React, { useState } from 'react';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  MenuProps,
  Tab,
  Tabs,
  withStyles
} from '@material-ui/core';
import Footer from '@components/Footer';
import { terms } from './TermsData';
import { CustomizedTypography } from '@components/Customized';
import { CaretDown, CaretUp, Checkmark } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { useStyles } from './styles';

type TermsType = 'service' | 'privacy' | 'marketing' | 'payment';
interface Props {
  urlParam?: TermsType;
}

const ServiceAndTermsPresenter: React.FC<Props> = ({
  urlParam = 'service'
}) => {
  const [value, setValue] = useState<TermsType>(urlParam);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const termsArr = terms[value];
  const [version, setVersion] = useState(0);
  const { tabs, box, contents } = useStyles();

  const handleChange = (num: number) => {
    setVersion(num);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box className={box}>
      <Tabs
        className={tabs}
        value={value}
        onChange={(_, value) => {
          setValue(value);
          setVersion(0);
        }}
      >
        <Tab
          value={'service'}
          label={
            <CustomizedTypography variant="body2">
              서비스 이용약관
            </CustomizedTypography>
          }
        />
        <Tab
          value={'privacy'}
          label={
            <CustomizedTypography variant="body2">
              개인정보처리방침
            </CustomizedTypography>
          }
        />
        <Tab
          value={'marketing'}
          label={
            <CustomizedTypography variant="body2">
              마케팅정보수신동의
            </CustomizedTypography>
          }
        />
        <Tab
          value={'payment'}
          label={
            <CustomizedTypography variant="body2">
              캐파결제약관
            </CustomizedTypography>
          }
        />
        <Tab
          value={'policy'}
          label={
            <CustomizedTypography variant="body2">
              서비스 운영 정책
            </CustomizedTypography>
          }
        />
      </Tabs>
      <div className={contents}>
        <div className="mobileList">
          <Button
            className="dropDown"
            onClick={handleClick}
            endIcon={
              anchorEl ? (
                <CaretUp width={24} height={24} color={colorSet.gray700} />
              ) : (
                <CaretDown width={24} height={24} color={colorSet.gray700} />
              )
            }
          >
            <CustomizedTypography variant="body1">
              {termsArr[version].title}
            </CustomizedTypography>
          </Button>
          <StyledMenu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {termsArr.map((v, i) => {
              return (
                <StyledMenuItem onClick={() => handleChange(i)}>
                  <CustomizedTypography variant="body2" fontWeight="500">
                    {v.title}
                  </CustomizedTypography>
                  {i === version && (
                    <Checkmark
                      width={20}
                      height={20}
                      color={colorSet.primary500}
                    />
                  )}
                </StyledMenuItem>
              );
            })}
          </StyledMenu>
        </div>

        <div className="desktopList">
          <CustomizedTypography variant="body1" fontWeight="700">
            문서
          </CustomizedTypography>
          {termsArr.map((v, i) => (
            <CustomizedTypography
              variant="body2"
              fontWeight="500"
              className={version === i ? 'selectedItem' : 'item'}
              onClick={() => handleChange(i)}
              key={i}
            >
              {v.title}
            </CustomizedTypography>
          ))}
        </div>
        <div className="term">
          <CustomizedTypography variant="h4" fontWeight="700">
            {termsArr[version].title}
          </CustomizedTypography>
          <pre
            dangerouslySetInnerHTML={{
              __html: termsArr[version].content
            }}
          ></pre>
        </div>
      </div>
      <Footer />
    </Box>
  );
};

export default ServiceAndTermsPresenter;

const StyledMenu = withStyles({
  paper: {
    width: 'calc(100% - 32px)',
    marginTop: '8px',
    border: `1px solid ${colorSet.gray400}`,
    borderRadius: '8px'
  }
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '6px 12px'
  }
}))(MenuItem);
